var accountsAndBudgets = angular.module('accountsAndBudgets', ['classy']);